























































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Emit, Prop } from "vue-property-decorator";

@Component
export default class CheckAuthLogin extends Vue {
    public valid = false;
    public username: string = "";
    public email: string = "";

    @Prop() authorizationActive!: boolean;
    @Prop() blocked!: boolean;

    @Emit() submit() {
        return { email: this.email, username: this.username };
    }

    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || (this.$t("studio.required") as string),
            username: v =>
                v.length < 255 || (this.$t("guest.username.invalid") as string),
            email: v =>
                /^$|^[\w.-]+@[\w.-]+$/gi.test(v) ||
                (this.$t("guest.email.invalid") as string),
        };
    }

    public validate() {
        (this.$refs.form as Vue & { validate: () => void }).validate();
    }
}
